import type { Ref } from 'vue'
import type { GtmEventName, GtmUserProperties } from '~/types/analytics'
import { isRef } from 'vue'
import useAuth from '~/store-v2/auth/useAuth'
import { GTM_USER_PROPERTY_KEYS } from '~/types/analytics'
import { pushToDataLayer } from '~/utils/analytics'
import { getAllowedUtmQuery } from '~/utils/utm'

export interface UseAnalyticsOptions {
  projectId?: Ref<string | undefined> | string
  financingId?: Ref<string | undefined> | string
}

function resolve(value: Ref<string | undefined> | string | undefined): string | undefined {
  if (value === undefined)
    return undefined
  const v = isRef(value) ? value.value : value
  return v?.toString().trim() || undefined
}

export function useAnalytics(options: UseAnalyticsOptions = {}) {
  const route = useRoute()
  const { data: auth } = useAuth()

  function getUserProperties(): GtmUserProperties {
    const me = auth.value?.me
    const person = auth.value?.person
    const profile = person?.profile
    const routeProjectId = 'id' in route.params ? route.params.id?.toString() : undefined

    return {
      userId: person?.id?.toString(),
      partnerId: me?.parceiro?.id?.toString() ?? person?.partner?.id?.toString(),
      projectId: resolve(options.projectId) ?? routeProjectId,
      financingId: resolve(options.financingId),
      profile,
      userType: profile,
      isAdmin: me?.perfil?.toLowerCase() === 'admin',
      ...getAllowedUtmQuery(route.query),
    }
  }

  function trackEvent(event: GtmEventName, extra: Record<string, unknown> = {}): void {
    const userProperties: GtmUserProperties = { ...getUserProperties() }
    const eventParams: Record<string, unknown> = {}

    for (const [key, value] of Object.entries(extra)) {
      if ((GTM_USER_PROPERTY_KEYS as readonly string[]).includes(key))
        (userProperties as Record<string, unknown>)[key] = value
      else
        eventParams[key] = value
    }

    pushToDataLayer(event, userProperties, eventParams)
  }

  return { trackEvent }
}
